<template>
  <router-link tag="div" class="container" :to="{name: 'SingleRoomTimetableView', params: {roomId: room.id, date: date} }">
    <h3 class="title">{{title}}</h3>
    <RoomStatusBar :bookings="bookings"></RoomStatusBar>
  </router-link>
</template>

<script>
import RoomStatusBar from '@/components/RoomStatusBar'
import { mapGetters } from 'vuex';

import types from '@/store/types'
import Booking from '@/store/modules/booking/types'

export default {
  name: 'RoomSelectButton',
  components: { RoomStatusBar },
  props: ['room', 'date'],
  computed: {
    title () {
      return this.room.name ? this.room.name : 'Title not found'
    },
    bookings () {
      return this.getBookingsByRoom(this.date, this.room.id) || [];
    },
    ...mapGetters([types.getters.GET_SELECTED_DATE]),
    ...mapGetters('Booking', [Booking.getters.GET_BOOKINGS_BY_ROOM])
  },
  mounted () {
    // console.log('RoomSelectButton', this.bookings);
    // console.log('RoomSelectButton id', this.room.id);
    // console.log('RoomSelectButton date', this.date);
  }
}
</script>

<style lang="scss" scoped>

  @import 'src/color.scss';
  @import 'src/values.scss';

  .container {
    font-weight: bold;
    //border-bottom: 5px solid $secondary-dark;
    background: $secondary;
    padding: 1em 2em;
    margin: 0.3em 0;
    color: $secondary-text;
    transition: $transition-time all;

    &:hover {
      background-color: $secondary-dark;
      cursor: pointer;
    }

  }

  .room-header:hover {
    border-color: $secondary;
  }

  .title {
    margin: 0 0 0.5em 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/RoomSelectButton.vue